import React, { FC, useEffect, useRef, useState, useMemo } from "react";
import { Button, Table, Upload, Tooltip, message, notification } from "antd";
import { YhBox } from "@/components/YhBox";
import { globalPrompt } from "@/components/message";
import { ColumnsType } from "antd/es/table";
import { usePurchaseApprovalDetailsModel } from "./purchaseApprovalDetailsModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import { IDetailList } from "../../purchaseApprovalType"
import useGlobalModel, { transOptions, getFindItem } from "@/model/globalModel";
import { ISelectOption } from "@/components/YhFormBox/Types";
import { IVRMshelfDetail, IVRMshelfSearch } from "@/views/base/warehouse/warehouseTypes";
import { warehouseService } from "@/views/base/warehouse/warehouseService";
import { formatNum, formatIntPoint, bigNumber } from "@/utils/utils";
import { DetailType } from "@/types/ScmEnums";
import { importPropsConfig } from "@/utils/importFile";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { YhBut } from "@/components/YhButton";
import { purchasePoService } from "@/views/purchase/po/purchasePoService";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { useDictModel } from "@/views/base/dict/dictModel";
import { PictureOutlined } from "@ant-design/icons";
import { LookPictureModal } from "@/views/lookPicture";
import onReturnIcon from '../../../../../assets/images/未转接.png'
export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const {
        detailAddList,
        detailDataSource,
        detailLookList,
        detaiAddDataRowKeys,
        detailDataRowKeys,
        detailEditForm,
        detailLookForm,
        detailAddForm,
        setDetaiAddDataRow,
        setDetailAddList,
        setDetaiAddDataRowKeys,
        setDetailDataRowKeys,
        setDetailDataRow,
        setAddModalVisible,
        setDetailDataSource,
        detailDetailList,
        downloadTpl,
        modelScreenMethod,
        setHistoryVisible,
        setHistoryRow,
        setTopButsControl
    } = usePurchaseApprovalDetailsModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();
    const formRef = useRef<any>()
    const typeList = {
        "add": detailAddList,
        "edit": detailDataSource,
        "look": detailLookList,
    }
    const { getSelectedDictOne, getTreeNodeName } = useDictModel();
    useEffect(() => {
        const dataList = mode === 'edit' ? detailDataSource : detailAddList
        formRef.current = dataList
    }, [detailAddList, detailDataSource])
    const typeForm: any = {
        add: detailAddForm,
        edit: detailEditForm,
        look: detailLookForm
    }

    const onHistoryModel = (record: IDetailList) => {
        setHistoryVisible(true)
        setHistoryRow(record)
    }
    const { warehouseList, shopAndOrg: { shopId, shopName }, setLoadingInfo } = useGlobalModel()
    //实时详情列表货位数据
    const [shelfAllList, setShelfAllList] = useState<IVRMshelfDetail[]>([]);
    const [loading, setLoading] = useState<boolean>(false)

    const importCallback = async (list: any) => {
        setLoadingInfo({ loadingVisible: false })
        console.log(list);
        if (list && list.length) {
            let noList = list.filter((item: any) => !item.status).map((list: any) => list.materialCode + ':' +
                list.msg)
            let newList = list.filter((item: any) => item.status)
            if (mode === "add") {
                setDetailAddList(newList);
                notification.warning({ message: '提醒', description: noList, duration: 9 })
            } else if (mode === "edit") {
                setDetailDataSource(newList);
            }
        }
    }

    // 删除(做限制)
    const onRemove = (mode: string) => {
        detailDetailList(mode)
    }
    const action = <>
        {((mode == "add" || (mode == "edit" && (typeForm[mode].status == "purchase_approval.init" || typeForm[mode].status == "purchase_approval.submit"))) && !typeForm[mode].oldCode) && <>
            <YhAuth resCode={ResourceAuthEnum.P_APPROVAL_ADDGOOD}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => setAddModalVisible(true)}
                >新增配件</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.P_APPROVAL_REMOVE}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => { onRemove(mode) }}
                >批量删除</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.P_APPROVAL_DOWNLOADMODAL}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={downloadTpl}
                >下载模板</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.P_APPROVAL_IMPORT}>
                <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/zzw-vrm/purchaseApproval/import`, importCallback, () => setLoadingInfo({ loadingVisible: true, txt: "快速导入中..." }), { shopId, shopName }, false)}>
                    <Button className="mr-5" type="primary" shape="round">导入</Button>
                </Upload>
            </YhAuth>
        </>}
    </>;

    const shelfChange = (value: string, option: ISelectOption, record: IDetailList, rowIndex: number) => {
        let newData = mode === "edit" ? detailDataSource : detailAddList;
        newData.splice(rowIndex, 1, record);
        mode === "edit" ? setDetailDataSource([...newData]) : setDetailAddList([...newData])
        setTopButsControl(true)
    }
    //货位触焦 
    const shelfFocus = async (record: IDetailList, rowIndex: number) => {
        setLoading(true)
        try {
            let newData = mode === "edit" ? detailDataSource : detailAddList;
            const newRow = newData[rowIndex];
            let warehouseCode = record["warehouseCode"]
            if (warehouseCode) {
                //货位列表  判断是当前仓库的货位列表  不做接口请求
                let newRecords = shelfAllList.find(item => item.warehouseCode === warehouseCode) ? shelfAllList : [];
                if (!newRecords.length) {
                    const { retData } = await warehouseService.shelfAllPage({
                        pageSize: 10000,
                        pageNum: 1,
                        warehouseCode,
                    } as IVRMshelfSearch)
                    newRecords = retData.map((item: IVRMshelfDetail) => { return { ...item, name: item.code } })
                    setShelfAllList(newRecords)
                }
                //查询配件有没有在改仓库下采购过，
                let { retData } = await purchasePoService.getMaterialShelf({
                    shopId,
                    materialCode: record.materialCode,
                    warehouseCode: warehouseCode
                })
                // 采购过的货位带出来不可以编辑， 其它的可以编辑(有临时货位默认带出临时货位)
                if (retData.shelfCode) {
                    newRow.shelfCode = retData.shelfCode ?? '';
                    newRow.shelfId = retData.shelfId ?? '';
                    newRow.isPurShelf = retData.shelfCode ?? '';  //做是否可编辑
                    message.warning(`自动匹配到配件【${record.materialCode}】在该仓库下采购的货位，货位不可做修改操作！！`)
                    newData.splice(rowIndex, 1, { ...record, ...newRow });
                    mode === "edit" ? setDetailDataSource([...newData]) : setDetailAddList([...newData])
                    setTopButsControl(true)
                }
            } else {
                setShelfAllList([]);
            }
            setLoading(false)
        } catch (e) {
            setLoading(false)
        }
    }
    const [imageModalVisible, setImageModalVisible] = useState(false);
    const [currentMaterialCode, setCurrentMaterialCode] = useState("");
    // 打开图片模态框
    const handleOpenImageModal = (materialCode: string) => {
        setCurrentMaterialCode(materialCode);
        setImageModalVisible(true);
    };
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const onPlanCode = (code: string) => {
        let supplierEditKey = "11-1-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: code, mode: "look", },
            true
        );
    }
    const onEnquiryCode = (code: string) => {
        let supplierEditKey = "11-6-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: code, mode: "look", },
            true
        );
    }
    // 关闭图片模态框
    const handleCloseImageModal = () => {
        setImageModalVisible(false);
        setCurrentMaterialCode("");
    };
    const defaultColumns = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '商品编码',
            width: 150,
            dataIndex: 'materialCode',
            render: (text: any, record: any) => (
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <YhTootip text={text} onClick={() => onHistoryModel(record)} style={{ maxWidth: "140px" }} />
                    <PictureOutlined
                        style={{ color: '#009688', cursor: 'pointer', marginLeft: 4, fontSize: '22px' }}
                        onClick={() => handleOpenImageModal(record.materialCode)} // 点击打开图片模态框
                    />
                </div>
            ),
        }, {
            title: '商品名称',
            width: 150,
            dataIndex: 'materialName',
            render: (text: any, record: any) => (
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    {text}
                    {record.enquiryCode && <Tooltip placement="topLeft" title={record.enquiryCode}><span style={{ background: "orange", color: "white", padding: '0 2px', cursor: 'pointer', marginLeft: '5px' }}>询</span></Tooltip>}
                </div>
            ),
        }, {
            title: '采购订单号',
            width: 180,
            dataIndex: 'planCode',
            render: (text: any, record: any) => (typeForm[mode].status == "purchase_approval.transfer" && !text && record.deleteFlag !== 1) ? <img src={onReturnIcon} alt="未转接" style={{ width: '48px', height: '28px' }} /> : <YhTootip text={text} onClick={() => onPlanCode(text)} style={{ width: 150 }} />,
        }, {
            title: '采购询价号',
            width: 160,
            dataIndex: 'enquiryCode',
            render: (text: any, record: any,) => <YhTootip text={text} style={{ width: 140 }} onClick={() => onEnquiryCode(text)} />,
        }, {
            title: '品牌',
            width: 80,
            dataIndex: 'brandName',
        }, {
            title: '上装品牌',
            width: 130,
            dataIndex: 'upperClothBrand',
            editable: (mode == "add" || (mode == "edit" && (typeForm[mode].status == "purchase_approval.init" || typeForm[mode].status == "purchase_approval.submit"))) ? true : false,

        }, {
            title: '底盘品牌',
            width: 130,
            dataIndex: 'chassisBrand',
            editable: (mode == "add" || (mode == "edit" && (typeForm[mode].status == "purchase_approval.init" || typeForm[mode].status == "purchase_approval.submit"))) ? true : false,

        }, {
            title: '适用车型',
            width: 130,
            dataIndex: 'vehicleModel',
            editable: (mode == "add" || (mode == "edit" && (typeForm[mode].status == "purchase_approval.init" || typeForm[mode].status == "purchase_approval.submit"))) ? true : false,
        }, {
            title: '规格型号',
            width: 120,
            dataIndex: 'model',
            editable: (mode == "add" || (mode == "edit" && (typeForm[mode].status == "purchase_approval.init" || typeForm[mode].status == "purchase_approval.submit"))) ? true : false,
            render: (text: any, record: any) => <YhTootip text={text} style={{ maxWidth: "120px" }} />,
        }, {
            title: '单位',
            width: 100,
            dataIndex: 'unitCode',
            editType: 'select',
            options: getSelectedDictOne(DictCodeEnmu.MATERIAL_UNIT),
            editable: (mode == "add" || (mode == "edit" && (typeForm[mode].status == "purchase_approval.init" || typeForm[mode].status == "purchase_approval.submit"))) ? true : false,
            render: (text: string) => getTreeNodeName(text as string),
        }, {
            title: '提交数量',
            width: 110,
            dataIndex: 'initNum',
            editable: ((mode == "add" || (mode == "edit" && typeForm[mode].status == "purchase_approval.init")) && !typeForm[mode].oldCode) ? true : false,
        }, {
            title: '确认数量',
            width: 110,
            dataIndex: 'confirmNum',
            editable: ((mode == "edit" && typeForm[mode].status == "purchase_approval.submit") && !typeForm[mode].oldCode) ? true : false,
        }, {
            title: '用途',
            width: 120,
            dataIndex: 'purpose',
            editable: (mode == "add" || (mode == "edit" && (typeForm[mode].status == "purchase_approval.init" || typeForm[mode].status == "purchase_approval.submit"))) ? true : false,
        }, {
            title: '备注',
            width: 120,
            dataIndex: 'note',
            editable: (mode == "add" || (mode == "edit" && (typeForm[mode].status == "purchase_approval.init" || typeForm[mode].status == "purchase_approval.submit"))) ? true : false,
        },
        ...(!typeForm[mode].oldCode ? [{
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            render: (text: any, record: any) =>
                mode == "add" || (mode == "edit" && typeForm[mode].status == "purchase_approval.init") ? <YhBut
                    type="delete"
                    txt="删除"
                    click={() => removeMaterial(record)}
                /> : mode == "edit" && typeForm[mode].status == "purchase_approval.submit" ? <YhBut
                    type="warning"
                    txt="作废"
                    click={() =>
                        globalPrompt("modal", {
                            title: "作废此条",
                            type: "warning",
                            text: "作废此条商品明细，是否确认？？",
                            okText: "确定",
                            onOk: () => { handleSave({ ...record, deleteFlag: 1 }) },
                            cancelText: "取消",
                            onCancel: () => { }
                        })}
                /> : <></>
        }] : []),
    ];

    const removeMaterial = (record: IDetailList) => {
        detailDetailList(mode, record)
    }

    const newSelectColumns = () =>
        defaultColumns.map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col?.rules,
                    options: col?.options,
                    editType: col?.editType,
                    editable: record.deleteFlag == 1 ? false : col?.editable,
                    onSelectChange: col?.onSelectChange,
                    onSelectFocus: col?.onSelectFocus,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleSave,
                }),
            }
        })

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "purchaseApproval", "roleCodes": roles };
        return getRoleColumns("purchaseApproval", "明细", newSelectColumns(), params);
    }, [roles, typeList[mode], defaultColumns]);
    const handleSave = async (row: IDetailList) => {
        let { initNum, confirmNum, purpose, note } = row
        row.initNum = +formatNum(initNum)
        if (mode == 'add' || detailEditForm.status == "purchase_approval.init") {
            row.confirmNum = +formatNum(initNum)
        } else {
            row.confirmNum = +formatNum(confirmNum)
        }
        row.unitName = getTreeNodeName(row.unitCode as string)
        let newData: any = formRef.current;
        const index = newData.findIndex((item: any) => row.materialCode === item.materialCode);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });
        mode === "edit" ? setDetailDataSource([...newData]) : setDetailAddList([...newData])
        setTopButsControl(true)
    }

    const setTypeDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode === DetailType.add) {
            setDetaiAddDataRowKeys(selectedRowKeys)
        } else if (mode === DetailType.edit) {
            setDetailDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeDetailDataRow = async (selectedRows: IDetailList[], mode: string) => {
        if (mode === DetailType.add) {
            setDetaiAddDataRow(selectedRows)
        } else if (mode === DetailType.edit) {
            setDetailDataRow(selectedRows)
        }
    }
    return (
        <YhBox title="配件信息" rightChildren={action} style={{ marginBottom: "10px", height: 'calc(100vh - 455px)' }}>
            <Table
                bordered
                loading={{ tip: "数据查询中...", spinning: loading }}
                rowClassName={(record) =>
                    (+Number(record.initNum) > +(record.confirmNum ?? 0) && record.initNum > 0) ? "editable-row ant-table-cell-fix-left yh-edit-table-tr background-FFB4B4" :
                        (+Number(record.initNum) < +(record.confirmNum ?? 0)) ? "editable-row yh-edit-table-tr background-bdc7fc" :
                            (record.deleteFlag == 1) ? "editable-row yh-edit-table-tr strikethrough" :
                                !record.planCode && typeForm[mode].status == 'purchase_approval.transfer' ? "editable-row yh-edit-table-tr strikethroughOrange" :
                                    'editable-row yh-edit-table-tr'
                }
                rowKey={record => record.materialCode as string}
                rowSelection={
                    mode === DetailType.look ? undefined : {
                        selectedRowKeys: mode === DetailType.add ? detaiAddDataRowKeys : detailDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IDetailList[]) => {
                            setTypeDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeDetailDataRow(selectedRows, mode)
                        }
                    }}
                columns={roleColumns}
                dataSource={typeList[mode]}
                pagination={false}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    }
                }}
                scroll={{ x: 'max-content', y: 'calc(100vh - 565px)' }} />
            <LookPictureModal
                visible={imageModalVisible}
                materialCode={currentMaterialCode}
                onClose={handleCloseImageModal}
            />
        </YhBox>

    )
}